module.exports = __webpack_public_path__ + "static/Millimetre-Regular_web-1c74a27c94b1cdb2492e43e8ccfde7f7.ttf";